export default {
    EXCEL: 'EXCEL',
    PDF: 'PDF',
    ZIP: 'ZIP',
    WORD: 'WORD',
    TXT: 'TXT'
};
